import { routeConstants } from "services/keyConstants";

const baseUrl = "/production-new";
const baseMp = `/${routeConstants.MAM_OF_PRODUCT}`;
const basePd = `/pd`;
const baseMaterialReconciliation = `/material-reconciliation`;

export const GET_ALL_PP = `${baseUrl}/format`;

export const GET_REQUISITION_SLIP = `${baseUrl}/format/requisition`;

export const DOWNLOAD_DOCUMENT = `${baseUrl}/format/download`;

export const GET_DATA = `${baseUrl}/format/`;

export const CREATE_PP = `${baseUrl}/format/`;

export const GET_BMR_DATA = `${baseUrl}/bmr/`;

export const DOWNLOAD_PRODUCT_MANUFACTURING = `${baseUrl}/format/download-formula`;

export const UPDATE_SPECIFIC_BMR_HISTORY = `${baseUrl}/format/specific/`;

export const PROJECTION = `/projection`;

export const GET_PRODUCT_INFO = `${baseUrl}/format/get-product-info`;

export const POST_MATERIAL_RECONSILIATION = `${baseUrl}${baseMaterialReconciliation}`;

export const DOWNLOAD_BMR = `${baseUrl}/bmr/download`;

export const GET_BY_DOCUMENT_NAME = `/preventive-maintenance/get-by-docname`;

export const CREATE_REWORK = `/control-of-non-confirming/create-rework`;

export const GET_PRODUCT_LIST = `${basePd}/product-list/get-product-with-quality-plan`;

export const GET_RAW_MATERIAL = `${basePd}/product-list/get-raw-material`;

export const CREATE_REQUISITION = `${baseUrl}/format/create-requisition`;

export const GET_BIFURCATION = `${baseUrl}/bmr/find-child`;

export const SPLIT_BMR = `${baseUrl}/bmr/split`;

export const GENERATE_STOCK_REGISTER = `${baseUrl}/stock-register/generate-stock-register`;

export const GET_COA_LIST_BY_BMR_ID = `${baseUrl}/format/certificate-of-analysis`;

export const GET_MATERIAL_RECONCILIATION = `${baseUrl}/format/material-reconciliation`;

export const GET_BATCH_RELEASE_CHECK_LIST = `${baseUrl}/format/batch-release-check-list`;

export const UPDATE_PURCHASE_STOCK_REGISTER = `${baseUrl}/stock-register/update/`;

export const DOWNLOAD_SEMI_FINISHED_STOCK = `${baseUrl}/stock-register/download`;

export const GET_PENDING_SEMI_FINISHED_STOCK_DATA = `${baseUrl}/stock-register/get-pending-list`;

export const GET_NCR = `/control-of-non-confirming/get-nc-by-bmr`;

//Dashboard

export const GET_COUNT_DASHBOARD = `${baseUrl}/bmr/get-count-dashboard`;

export const GET_CHART_DASHBOARD = `${baseUrl}/bmr/get-chart-data`;
